export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserProfile.vue?vue&type=style&index=0&id=09e88f81&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/userprofile/UserProfile.vue?vue&type=style&index=0&id=09e88f81&prod&scoped=true&lang=css&
// module id = 1561
// module chunks = 0